import React from 'react'
import Shimmer from './Shimmer'

const ImageShimmer = ({ customHeight, className }) => {
    return (
        <Shimmer className={`${className ? className: "w-full rounded-lg"} ${customHeight ? customHeight : "min-h-[21vh]"} bg-gray-400`} />
    )
}

export default ImageShimmer